import React from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

interface StepTransitionProps {
  /** Changes whenever the content should animate to its next state, e.g. the current step. */
  stepKey: string;
  children: React.ReactNode;
  className?: string;
}

// A slow-settling ease-out: quick to start, gentle to land.
const EASE = [0.22, 1, 0.36, 1] as const;

/**
 * Cross-fades between steps of a flow with a short upward drift. With "reduce motion" on,
 * it only fades. The outgoing step leaves before the next one enters, so heights never stack.
 */
const StepTransition: React.FC<StepTransitionProps> = ({ stepKey, children, className }) => {
  const reduceMotion = useReducedMotion();
  const offset = reduceMotion ? 0 : 12;
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={stepKey}
        className={className}
        initial={{ opacity: 0, y: offset }}
        animate={{ opacity: 1, y: 0, transition: { duration: reduceMotion ? 0.15 : 0.38, ease: EASE } }}
        exit={{ opacity: 0, y: -offset / 2, transition: { duration: reduceMotion ? 0.1 : 0.18, ease: 'easeIn' } }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default StepTransition;
